import { RxCaretLeft } from "react-icons/rx";
import { RxCaretRight } from "react-icons/rx";

const Pagination = ({
  totalItems,
  currentPage,
  itemsPerPage,
  onPageChange,
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startCount = (currentPage - 1) * itemsPerPage + 1;
  const endCount = Math.min(startCount + itemsPerPage - 1, totalItems);

  return (
    <div className="pagination-container flex justify-between items-center py-4 px-4 rounded">
      <span className="text-purple-500">
        Showing {startCount} of {totalItems}
      </span>

      <div className="flex gap-4">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`pagination-btn flex items-center`}
        >
          <div className="bg-black-200 rounded-full mr-2">
            <RxCaretLeft color="white" size={18} />
          </div>
          Previous
        </button>
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`pagination-btn flex items-center`}
        >
          Next
          <div className="bg-black-200 rounded-full ml-2">
            <RxCaretRight color="white" size={18} />
          </div>
        </button>
      </div>
    </div>
  );
};

export default Pagination;
